import { handleError } from '@anchorage/sentry';
import type { ErrorInfo } from 'react';

/**
 * `react-error-boundary` `onError` handler that forwards the React component
 * stack to Sentry.
 *
 * For a render-phase crash the component stack is the single most useful
 * breadcrumb — it names the offending component subtree — but the base
 * `handleError` signature drops it unless it's passed via `extraContext`.
 */
export function reportRenderError(error: Error, info: ErrorInfo): void {
  handleError(error, {
    extraContext: { componentStack: info.componentStack ?? undefined },
  });
}
